// extracted by mini-css-extract-plugin
export var alignCenter = "_bk-d";
export var bannerShown = "_bk-6";
export var buttonContent = "_bk-0";
export var cardList = "_bk-1";
export var centerContent = "_bk-2";
export var chevron = "_bk-3";
export var closePanelButton = "_bk-k";
export var conversationContextContainer = "_bk-l";
export var conversationDetailContainer = "_bk-4";
export var detailWrapper = "_bk-7";
export var dropdownButton = "_bk-e";
export var dropdownTitle = "_bk-9";
export var fullHeight = "_bk-5";
export var hidden = "_bk-a";
export var icon = "_bk-b";
export var mergeSuggestionWrapper = "_bk-m";
export var panel = "_bk-i";
export var portalButtonsWrapper = "_bk-c";
export var right = "_bk-j";
export var tableSummaryContainer = "_bk-8";
export var tableSummaryHeader = "_bk-g";
export var threeDotsButton = "_bk-f";
export var wide = "_bk-h";